var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import classNames from 'classnames';
import { StringMode } from './string';
import { ImagePreview } from '@comall-backend-builder/components-basis';

var StringImageTextMode = function (_super) {
  __extends(StringImageTextMode, _super);

  function StringImageTextMode() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * 获取展示组件
   */


  StringImageTextMode.prototype.getAvailableDisplayComponent = function (value, displayInfo) {
    var className = displayInfo.className,
        style = displayInfo.style,
        alt = displayInfo.alt,
        preview = displayInfo.preview; // 图片配置信息

    var imageConfig = {
      className: classNames('type-string mode-string-image-text', className),
      style: style,
      src: value,
      alt: alt ? alt : value
    }; // 预览组件配置信息

    var previewProps = __assign(__assign({}, preview), {
      type: 'popover',
      imageConfig: imageConfig
    });

    return React.createElement(ImagePreview, __assign({}, previewProps));
  };

  return StringImageTextMode;
}(StringMode);

export { StringImageTextMode };